import React from 'react';
import { ShieldCheck, Sparkles, Phone } from 'lucide-react';
import { Button } from '../ui/button';
import { company } from '../../mock';
import ConsultationForm from './ConsultationForm';
import { useI18n } from '../../i18n';

const Hero = () => {
  const { t } = useI18n();
  const stats = [
    { value: '13+', label: t('hero.stats.years') },
    { value: '5',   label: t('hero.stats.offices') },
    { value: '1000+', label: t('hero.stats.projects') },
    { value: '98%', label: t('hero.stats.retention') },
  ];

  return (
    <section id="home" className="relative pt-28 pb-20 lg:pt-36 lg:pb-24 overflow-hidden">
      <div className="absolute inset-0 -z-10 bg-slate-950" />
      <div
        className="absolute inset-0 -z-10 opacity-40"
        style={{
          backgroundImage:
            "radial-gradient(1200px 500px at 15% -10%, rgba(59,130,246,0.25), transparent 60%), radial-gradient(900px 500px at 100% 10%, rgba(249,115,22,0.18), transparent 60%)",
        }}
      />
      <div
        className="absolute inset-0 -z-10 opacity-[0.08]"
        style={{
          backgroundImage:
            "linear-gradient(to right, rgba(255,255,255,0.35) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,0.35) 1px, transparent 1px)",
          backgroundSize: '48px 48px',
        }}
      />

      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7">
          <div className="inline-flex items-center gap-2 text-xs sm:text-sm px-3 py-1.5 rounded-full border border-white/15 bg-white/5 text-slate-200">
            <ShieldCheck className="h-4 w-4 text-emerald-400" />
            {t('hero.badge')}
          </div>

          <h1 className="mt-6 text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white leading-[1.05] tracking-tight">
            {t('hero.titleA')} <span className="text-orange-400">{t('hero.titleB')}</span>{t('hero.titleC')}
            <br />
            {t('hero.titleD')} <span className="text-blue-400">{t('hero.titleE')}</span>{t('hero.titleF')}
          </h1>

          <p className="mt-6 text-lg text-slate-300 max-w-2xl">
            {t('hero.subtitleLead')} <span className="text-white font-semibold">{t('hero.countries')}</span> {t('hero.subtitleRest')}
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            <a href={`tel:${company.phoneRaw}`}>
              <Button className="bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-md h-12 px-6">
                <Phone className="h-4 w-4 mr-2" /> {t('common.getFreeConsultation')}
              </Button>
            </a>
            <a href="#services">
              <Button variant="outline" className="bg-transparent border-white/20 text-white hover:bg-white/10 h-12 px-6">
                <Sparkles className="h-4 w-4 mr-2 text-blue-400" /> {t('common.exploreServices')}
              </Button>
            </a>
          </div>

          <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-4 max-w-2xl">
            {stats.map((s) => (
              <div key={s.label} className="rounded-xl border border-white/10 bg-white/5 backdrop-blur-sm p-4">
                <div className="text-2xl font-bold text-white">{s.value}</div>
                <div className="text-xs text-slate-400 mt-1">{s.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5">
          <ConsultationForm />
        </div>
      </div>
    </section>
  );
};

export default Hero;
